import QuantitySelectView from '../../views/library/quantity-select.view';
import * as React from 'react';
import { connect } from 'react-redux';
import { IPriceType } from '../../custom/classes/production';
import { IPackageListingAppState } from '../../redux-state/index';
import { updatePriceTypeQuantity, clearPriceTypeQuantities } from '../../redux-state/actions/package-listing.actions';
import { flatMap, uniqBy } from 'lodash';


interface StateToProps {
    packagePriceTypes: Array<IPriceType>;
    selectedPriceTypeQuantities: Map<number, number>;
    selectTicketsText: string;
    isUnseatedReservation: boolean;
}

interface DispatchToProps {
    selectPriceTypeQuantity: (priceTypeId, quantity) => void;
    resetPriceTypeQuantities: () => void;
}

export type QuantitySelectProps = StateToProps & DispatchToProps;


export class QuantitySelectBase extends React.Component<QuantitySelectProps, any> {
    constructor(props: QuantitySelectProps) {
        super(props);
    }

    componentDidMount() {
        if (this.props.selectedPriceTypeQuantities.size == 0 && this.props.packagePriceTypes.length == 1) {
            this.props.selectPriceTypeQuantity(this.props.packagePriceTypes[0].priceTypeId, 1);
        }
    }

    render() {
        return <QuantitySelectView {...this.props} {...this.state} />;
    }
}

function mapStateToProps(state: IPackageListingAppState): StateToProps {
    return {
        packagePriceTypes: state.packageListingSettings.isFixed ?
            uniqBy(flatMap(state.packageListing.packages.map(p => p.packagePriceTypes)), pt => pt.priceTypeId)
            : uniqBy(state.packageListing.packageDetail.packagePriceTypes, pt => pt.priceTypeId),
        selectTicketsText: state.packageListingText.selectTicketsTitle,
        selectedPriceTypeQuantities: state.packageListing.priceTypeQuantity,
        isUnseatedReservation: state.packageListingSettings.useUnseatedReservation
    }
}

function mapDispatchToProps(dispatch, ownProps: QuantitySelectProps): DispatchToProps {
    return {
        selectPriceTypeQuantity: (ptId, quantity) => {
            dispatch(updatePriceTypeQuantity(ptId, quantity));
        },
        resetPriceTypeQuantities: () => {
            dispatch(clearPriceTypeQuantities());
        }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(QuantitySelectBase);